__turbopack_context__.v({
  "actionBtn": "shorts-module__vhh5bq__actionBtn",
  "actionBtnActive": "shorts-module__vhh5bq__actionBtnActive",
  "actionCount": "shorts-module__vhh5bq__actionCount",
  "actions": "shorts-module__vhh5bq__actions",
  "audioButton": "shorts-module__vhh5bq__audioButton",
  "audioControls": "shorts-module__vhh5bq__audioControls",
  "audioRange": "shorts-module__vhh5bq__audioRange",
  "authorAvatar": "shorts-module__vhh5bq__authorAvatar",
  "authorAvatarImg": "shorts-module__vhh5bq__authorAvatarImg",
  "authorHandle": "shorts-module__vhh5bq__authorHandle",
  "authorMeta": "shorts-module__vhh5bq__authorMeta",
  "authorName": "shorts-module__vhh5bq__authorName",
  "authorRow": "shorts-module__vhh5bq__authorRow",
  "bottom": "shorts-module__vhh5bq__bottom",
  "bottomWithPlyr": "shorts-module__vhh5bq__bottomWithPlyr",
  "category": "shorts-module__vhh5bq__category",
  "channelAvatar": "shorts-module__vhh5bq__channelAvatar",
  "channelHandle": "shorts-module__vhh5bq__channelHandle",
  "channelRow": "shorts-module__vhh5bq__channelRow",
  "commentsBackdrop": "shorts-module__vhh5bq__commentsBackdrop",
  "commentsBody": "shorts-module__vhh5bq__commentsBody",
  "commentsClose": "shorts-module__vhh5bq__commentsClose",
  "commentsHeader": "shorts-module__vhh5bq__commentsHeader",
  "commentsSheet": "shorts-module__vhh5bq__commentsSheet",
  "commentsTitle": "shorts-module__vhh5bq__commentsTitle",
  "descAuthorBlock": "shorts-module__vhh5bq__descAuthorBlock",
  "descAuthorHandle": "shorts-module__vhh5bq__descAuthorHandle",
  "descAuthorLabel": "shorts-module__vhh5bq__descAuthorLabel",
  "descAuthorLink": "shorts-module__vhh5bq__descAuthorLink",
  "descAvatar": "shorts-module__vhh5bq__descAvatar",
  "descBackdrop": "shorts-module__vhh5bq__descBackdrop",
  "descBody": "shorts-module__vhh5bq__descBody",
  "descCategoryLink": "shorts-module__vhh5bq__descCategoryLink",
  "descChannel": "shorts-module__vhh5bq__descChannel",
  "descClose": "shorts-module__vhh5bq__descClose",
  "descHandle": "shorts-module__vhh5bq__descHandle",
  "descHeader": "shorts-module__vhh5bq__descHeader",
  "descHeadline": "shorts-module__vhh5bq__descHeadline",
  "descPanel": "shorts-module__vhh5bq__descPanel",
  "descStat": "shorts-module__vhh5bq__descStat",
  "descStats": "shorts-module__vhh5bq__descStats",
  "descText": "shorts-module__vhh5bq__descText",
  "descTitle": "shorts-module__vhh5bq__descTitle",
  "dragging": "shorts-module__vhh5bq__dragging",
  "feedProgressRemaining": "shorts-module__vhh5bq__feedProgressRemaining",
  "feedYoutubeProgress": "shorts-module__vhh5bq__feedYoutubeProgress",
  "frame": "shorts-module__vhh5bq__frame",
  "mediaLayer": "shorts-module__vhh5bq__mediaLayer",
  "meta": "shorts-module__vhh5bq__meta",
  "playbackSurface": "shorts-module__vhh5bq__playbackSurface",
  "scrollRoot": "shorts-module__vhh5bq__scrollRoot",
  "sharedYoutubeFrame": "shorts-module__vhh5bq__sharedYoutubeFrame",
  "sharedYoutubeLayer": "shorts-module__vhh5bq__sharedYoutubeLayer",
  "sharedYoutubeLayerPreload": "shorts-module__vhh5bq__sharedYoutubeLayerPreload",
  "shortPlyrError": "shorts-module__vhh5bq__shortPlyrError",
  "shortPlyrHost": "shorts-module__vhh5bq__shortPlyrHost",
  "shortPlyrLoading": "shorts-module__vhh5bq__shortPlyrLoading",
  "shortPlyrMount": "shorts-module__vhh5bq__shortPlyrMount",
  "shortPlyrSpinner": "shorts-module__vhh5bq__shortPlyrSpinner",
  "shortYoutubeFrame": "shorts-module__vhh5bq__shortYoutubeFrame",
  "shortYoutubeHost": "shorts-module__vhh5bq__shortYoutubeHost",
  "shortYoutubeMount": "shorts-module__vhh5bq__shortYoutubeMount",
  "shortYoutubePreload": "shorts-module__vhh5bq__shortYoutubePreload",
  "shortYoutubeVeil": "shorts-module__vhh5bq__shortYoutubeVeil",
  "shortsFadeOut": "shorts-module__vhh5bq__shortsFadeOut",
  "shortsPlyrSpin": "shorts-module__vhh5bq__shortsPlyrSpin",
  "slide": "shorts-module__vhh5bq__slide",
  "slideOpaque": "shorts-module__vhh5bq__slideOpaque",
  "slideTrack": "shorts-module__vhh5bq__slideTrack",
  "title": "shorts-module__vhh5bq__title",
  "titleButton": "shorts-module__vhh5bq__titleButton",
  "titleClamp": "shorts-module__vhh5bq__titleClamp",
  "youtubeProgress": "shorts-module__vhh5bq__youtubeProgress",
});
